import { render, staticRenderFns } from "./HorizontalNavMenuHeaderGroup.vue?vue&type=template&id=17b4ae82&"
import script from "./HorizontalNavMenuHeaderGroup.vue?vue&type=script&lang=js&"
export * from "./HorizontalNavMenuHeaderGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17b4ae82')) {
      api.createRecord('17b4ae82', component.options)
    } else {
      api.reload('17b4ae82', component.options)
    }
    module.hot.accept("./HorizontalNavMenuHeaderGroup.vue?vue&type=template&id=17b4ae82&", function () {
      api.rerender('17b4ae82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/@core/layouts/layout-horizontal/components/horizontal-nav-menu/components/horizontal-nav-menu-header-group/HorizontalNavMenuHeaderGroup.vue"
export default component.exports